<div class="container">
  <div class="row">
    <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
      <div class="card card-signin my-5">
        <div class="card-body">
          <img class="logo" src="/assets/famulus_logo.png" alt="Famulus" />
          <h5 class="card-title text-center">
            {{ "login.login" | translate }}
          </h5>
          <form (ngSubmit)="onSignin(f)" #f="ngForm">
            <div class="form-group">
              <label for="username">{{ "login.username" | translate }}</label>
              <input
                type="text"
                id="username"
                name="username"
                ngModel
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label for="password">{{ "login.password" | translate }}</label>
              <div class="input-group">
                <input
                  type="{{ showPassword ? 'text' : 'password' }}"
                  id="password"
                  name="password"
                  ngModel
                  class="form-control"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i
                      class="fa"
                      [ngClass]="{
                        'fa-eye-slash': !showPassword,
                        'fa-eye': showPassword,
                      }"
                      (click)="toggleVisibility()"
                    ></i>
                  </span>
                </div>
              </div>
            </div>
            @if (!environment.local) {
              <div style="justify-self: center; display: flex">
                <ngx-turnstile
                  #turnstile
                  [siteKey]="siteKey"
                  theme="light"
                  id="turnstileToken"
                  name="turnstileToken"
                  ngModel
                  (expired)="onTurnstileExpired()"
                ></ngx-turnstile>
              </div>
            }
            <a
              href="/recovery"
              class="recover-password"
              (click)="redirectToRecovery()"
              >{{ "login.forgot" | translate }}</a
            >
            <div class="text-center">
              <button class="btn btn-primary btn-signin" type="submit">
                {{ "login.login" | translate }}
              </button>
            </div>
            <div class="text-center" *ngIf="loginErrorCode">
              <div
                class="error"
                style="padding: 15px 0; color: red; font-weight: bold"
                [ngSwitch]="loginErrorCode"
              >
                <span *ngSwitchCase="600">{{
                  "login.error600" | translate
                }}</span>
                <span *ngSwitchCase="601">{{
                  "login.error601" | translate
                }}</span>
                <span *ngSwitchCase="602">{{
                  "login.error602" | translate
                }}</span>
                <span *ngSwitchCase="603">{{
                  "login.error603" | translate
                }}</span>
                <span *ngSwitchCase="616">{{
                  "login.error616" | translate
                }}</span>
                <span *ngSwitchCase="500">{{
                  "login.error500" | translate
                }}</span>
                <span *ngSwitchDefault>{{
                  "login.errorDefault" | translate
                }}</span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
